import React from "react";

import colors from "../../theme";

import { DataGrid } from "@mui/x-data-grid";

const TableDatagrid = ({ data, columns, isMobile, fontSize = "10px" }) => {
  return (
    <DataGrid
      sx={{
        fontSize: { xs: fontSize, md: "14px" },
        ".MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": {
          marginTop: "1em",
          marginBottom: "1em",
        },
        ".MuiDataGrid-scrollbarFiller.MuiDataGrid-scrollbarFiller--header": {
          backgroundColor: colors.secondary,
        },
        ".data-grid-header": {
          backgroundColor: colors.secondary,
          color: colors.text,
        },
        "& .editable-row .MuiDataGrid-row": {
          backgroundColor: `${colors.mainContentBgColor} !important`,
        },
        "& .editable-row .MuiDataGrid-cell": {
          backgroundColor: `${colors.mainContentBgColor} !important`,
        },
        "& .MuiDataGrid-cell": {
          lineHeight: isMobile ? { xs: "2.5 !important", md: "auto" } : "auto",
        },
      }}
      disableColumnMenu
      disableColumnSorting
      disableColumnSelector
      rows={data}
      columns={columns}
      editMode="row"
      initialState={{
        pagination: { paginationModel: { pageSize: 10 } },
        sorting: {
          sortModel: [{ field: "sessionId", sort: "desc" },{ field: "segmentIndex", sort: "asc" }],
        },
      }}
      pageSizeOptions={[10]}
    />
  );
};

export default TableDatagrid;
